import { render } from "./CommunicationContainer.vue?vue&type=template&id=3ed7d460&scoped=true&ts=true"
import script from "./CommunicationContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationContainer.vue?vue&type=script&lang=ts"

import "./CommunicationContainer.vue?vue&type=style&index=0&id=3ed7d460&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed7d460"]])

export default __exports__